import { useState } from "react";
import { api } from "../../../../../../../../utility/api";

export const ProduccionesApi = () => {
    const [cargando, setCargando] = useState(false);

    const getProducciones = async (params) => {
        try {
            setCargando(true);
            const response = await api.get("produccion_v2", params);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const deleteProduccion = async (id) => {
        try {
            setCargando(true);
            const response = await api.eliminar(`produccion_v2/${id}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getProducciones,
        deleteProduccion,

        cargando,
    };
};
